import FeaturesSection from './FeaturesSection'

export default FeaturesSection
